module.exports = __webpack_public_path__ + "fonts/UcCo3FwrK3iLTcvmYwYZ8UA3J58.b802662.woff2";